var map = {
	"./air.svg": 98675,
	"./bms.svg": 82397,
	"./boiler.svg": 36978,
	"./cold.svg": 84283,
	"./dry.svg": 36296,
	"./heat.svg": 247,
	"./pet.svg": 10556,
	"./waste.svg": 8921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92548;